import { useEffect } from 'react';
import PropTypes from 'react-proptypes';
import { connect } from 'react-redux';
import { SplitDateInputComponent, SwitchComponent } from '@dnhb/node_package';
import { dispatchMapper, INIT, SYNC } from '../../../shared/wizard/actions';
import { shapeInput, shapeOutput } from '../config';
import Analytics from 'shared/utility/analytics';
import { useLocation, useNavigate } from 'react-router-dom';

const WizardLanding = ({ pages, dispatch, forward, recalculating, input, sync, output: { errors } }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (pages.length > 3 && typeof recalculating !== 'number') {
      dispatch({ type: INIT, location, navigate, payload: { pages: pages.slice(0, 3) } });
    }
    dispatch({ type: SYNC, syncing: false, location, navigate });
    Analytics.send('Navigeer', 'Voorpagina');
  }, [dispatch, pages, recalculating]);

  return (
    <form onSubmit={forward(recalculating, location, navigate)}>
      <input type="submit" className="hidden" />
      <div className="wrapper">
        <h2>Uw persoonlijke gegevens</h2>
        <h3>Uw geboortedatum</h3>
        <div className="row group">
          <SplitDateInputComponent
            name="dob"
            onChangeHandler={sync('applicant_dob')}
            day={input.applicant_dob.day}
            month={input.applicant_dob.month}
            year={input.applicant_dob.year}
            errors={errors.applicant_dob}
          />
        </div>
        <div className="row">
          <div className="group col-xs-12">
            <h3>Heeft u een partner? {input.applicant_has_partner}</h3>
            <SwitchComponent
              id="exists"
              onChangeHandler={sync('applicant_has_partner')}
              value={input.applicant_has_partner}
              errors={errors.applicant_has_partner}
            />
          </div>
        </div>
        {input.applicant_has_partner ? (
          <div className="row">
            <div className="group col-xs-12">
              <h3>Geboortedatum partner</h3>
              <div className="row">
                <SplitDateInputComponent
                  name="partner_dob"
                  onChangeHandler={sync('partner_dob')}
                  day={input.partner_dob.day}
                  month={input.partner_dob.month}
                  year={input.partner_dob.year}
                  errors={errors.partner_dob}
                />
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </form>
  );
};

WizardLanding.propTypes = {
  sync: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  forward: PropTypes.func.isRequired,
  recalculating: PropTypes.number,
  input: shapeInput.isRequired,
  output: shapeOutput.isRequired,
  pages: PropTypes.arrayOf(PropTypes.string).isRequired,
};

WizardLanding.defaultProps = {
  recalculating: null,
};

export default connect(
  state => ({
    recalculating: state.recalculating,
    syncing: state.syncing,
    input: state.input,
    output: state.output,
    pages: state.pages,
  }),
  dispatchMapper
)(WizardLanding);
